// extracted by mini-css-extract-plugin
module.exports = {"pendingReservationContainer":"pendingReservations_pendingReservationContainer__WB4Di","separator":"pendingReservations_separator__FPJcd"};